<div class='feature-icon'>
  @if (type == '3D') {
    <i class='fas fa-cube p-2 fa-xs'></i>
  }
  @if (type == 'assets') {
    <i class='fas fa-list-check p-2 fa-xs'></i>
  }
  @if (type == 'cutOut') {
    <i class="fas fa-scissors p-2 fa-xs"></i>
  }
  @if (type == 'geojson') {
    <i class="fas fa-map-location-dot p-2 fa-xs"></i>
  }
  @if (type == 'group') {
    <i class="fas fa-list p-2 fa-xs"></i>
  }
  @if (type == 'icon') {
    <i class="fa-solid fa-tag p-2 fa-sm"></i>
  }
  @if (type == 'image') {
    <i class='far fa-image p-2 fa-xs'></i>
  }
  @if (type == 'label') {
    <i class='fas fa-font p-2 fa-xs'> </i>
  }
  @if (type == 'line') {
    <i class="fa-solid fa-minus p-2 fa-xs"></i>
  }
  @if (type == 'marker') {
    <i class="fas fa-map-marker-alt p-2 fa-xs"></i>
  }
  @if (type == 'polygon') {
    <i class="fa-solid fa-draw-polygon p-2 fa-xs"></i>
  }
  @if (type == 'rasterImage') {
    <i class="fa-solid fa-layer-group p-2 fa-xs"></i>
  }
  @if (type == 'view') {
    <i class="fas fa-street-view p-2 fa-xs"></i>
  }
</div>